import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  useTheme,
} from "@mui/material";
import React, { Fragment } from "react";
import { AppendIfPrefixExists } from "../../../../modules/sitePaths";
import { NavLinkStyles } from "../styles/NavigationStyles";
import { NavItemType } from "./NavigationTypes";
import { NavLink as RouterLink } from "react-router-dom";
import { telemetryProps } from "shared-ui/src/instrumentation/gtm";

interface NavLinkProps {
  navItem: NavItemType;
  tier: number;
  parentContext: string;
}
export default function NavLink({
  navItem,
  tier,
  parentContext,
}: NavLinkProps) {
  const theme = useTheme();
  const styles = NavLinkStyles(theme);

  if (!navItem.visible) {
    return <Fragment />;
  }

  return (
    <ListItemButton
      sx={[
        tier === 2 ? styles.nested : {},
        tier === 3 ? styles.nested2 : {},
        {
          "&.active": {
            backgroundColor: "action.selected",
          },
          "&:hover": {
            backgroundColor: "action.selected",
          },
          "&.Mui-focusVisible": {
            backgroundColor: "primary.main",
            color: "primary.contrastText",
            outline: "2px solid",
            outlineColor: "primary.dark",
            outlineOffset: "-2px",
            "& .MuiListItemIcon-root": {
              color: "inherit",
            },
          },
        },
        navItem.id.startsWith("standards-folder-") ? { py: 0.2 } : {},
      ]}
      component={RouterLink}
      to={AppendIfPrefixExists(navItem.path)}
      {...(navItem.target && { target: navItem.target })}
      {...telemetryProps({
        name: "nav_link",
        section: "navigation",
        label: `${parentContext} > ${navItem.displayName}`,
        id: navItem.id,
      })}
    >
      {navItem.icon && (
        <ListItemIcon sx={styles.listItemIcon}>{navItem.icon}</ListItemIcon>
      )}
      <ListItemText
        primary={navItem.displayName}
        sx={[tier === 1 ? styles.listItemText : {}]}
      />
    </ListItemButton>
  );
}
